var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.OpisiPaketa),function(opis){return _c('div',{staticClass:"izpis-opisa-zascita-varnost"},[_c('img',{attrs:{"src":"/static/img/kljukica2.svg"}}),_vm._v("\n    "+_vm._s(opis)+"\n  ")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-88d6bf8e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Naroci/NarociInternet/InfoKomponentaOpisPandaPaketa.vue
// module id = TYdw
// module chunks = 3